export default __webpack_public_path__ + "static/media/ApolloAvatar.6f3713fe.svg";